import { type UseMutationResult, useMutation } from '@tanstack/react-query';

import api from '@/api/axios';
import { queryClient } from '@/app/config/react-query';
import { useErrorHandling } from '@/hooks/useErrorHandling';
import type { CreateAuditCaseResponse } from '@/types';

interface CreateAuditCaseForNewAuditParams {
  supplierId: string;
  moduleIds: string[];
  certificationBodyId?: string;
  inputFile: string;
}

const createAuditCaseForNewAudit = async ({
  supplierId,
  moduleIds,
  certificationBodyId,
  inputFile,
}: CreateAuditCaseForNewAuditParams): Promise<CreateAuditCaseResponse> => {
  const { data } = await api.post<CreateAuditCaseResponse>('/audit-cases/create-for-new-audit', {
    supplierId,
    moduleIds,
    certificationBodyId,
    inputFile,
  });

  return data;
};

export const useCreateAuditCaseForNewAudit = (): UseMutationResult<
  CreateAuditCaseResponse,
  unknown,
  CreateAuditCaseForNewAuditParams
> => {
  const handleErrors = useErrorHandling();

  return useMutation({
    mutationFn: createAuditCaseForNewAudit,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['self-assessments'] });
    },
    onError: (error: unknown) => {
      handleErrors(error);
    },
  });
};
